import moment from "moment";
import { normalize } from "@/utils/healthText";

export const HEALTH_LABELS = {
  congenitalDisease: "โรคประจำตัว",
  allergic: "แพ้ยา",
  medicationHistory: "ยาที่ใช้",
  antithrombotic: "ต้านเกล็ดเลือด",
};
export const SOURCE_LABELS = { CHECKIN: "เคาน์เตอร์", DASHBOARD: "ห้องตรวจ" };

export function isHealthReviewed(props) {
  return !!props?.healthReviewDt;
}

export function canAcknowledge(props) {
  return props?.statusId === 5 && isHealthReviewed(props);
}

const APPEND_SEPARATOR = /^\s*[,;\n]/;

export function describeHealthChanges(changes) {
  if (!changes) return [];
  const lines = [];
  Object.keys(HEALTH_LABELS).forEach(field => {
    const change = changes[field];
    if (!change) return;
    const label = HEALTH_LABELS[field];
    if (field === "antithrombotic") {
      const fromFlag = !!change.from;
      const toFlag = !!change.to;
      if (fromFlag === toFlag) return;
      lines.push(`${toFlag ? "+" : "−"} ${label}`);
      return;
    }
    const from = String(change.from ?? "").trim();
    const to = String(change.to ?? "").trim();
    if (from === to) return;
    if (!from) lines.push(`+ ${label} ${to}`);
    else if (!to) lines.push(`− ${label}`);
    else if (to.startsWith(from) && APPEND_SEPARATOR.test(to.slice(from.length))) {
      const added = to.slice(from.length).replace(/^\s*[,;\n]+\s*/, "");
      lines.push(`+ ${label} ${added}`);
    } else lines.push(`${label}: ${from} → ${to}`);
  });
  return lines;
}

/**
 * Fields whose draft value differs from the snapshot the draft was built from.
 * Strings are compared normalized (so "-" vs ปฏิเสธ is not an edit), antithrombotic
 * as a boolean. Only these fields may be sent, so untouched (possibly stale) values
 * are never written back.
 */
export function editedHealthFields(snapshot, draft) {
  const edited = {};
  ["congenitalDisease", "allergic", "medicationHistory"].forEach(field => {
    const before = normalize(snapshot?.[field]);
    const after = normalize(draft?.[field]);
    if (before !== after) edited[field] = after;
  });
  if (!!snapshot?.antithrombotic !== !!draft?.antithrombotic) {
    edited.antithrombotic = !!draft?.antithrombotic;
  }
  return edited;
}

export function healthEditDraft(patient) {
  return {
    congenitalDisease: normalize(patient?.congenitalDisease),
    allergic: normalize(patient?.allergic),
    medicationHistory: normalize(patient?.medicationHistory),
    antithrombotic: !!patient?.antithrombotic,
  };
}

/** "15 ต.ค. 69 10:01 โดย ฝน" — when and by whom; the name is left out when unknown. */
export function stampText(dt, user) {
  if (!dt) return "";
  const when = moment(dt).format("D MMM YY HH:mm");
  const name = user?.firstNameTh || "";
  return name ? `${when} โดย ${name}` : when;
}
